import { captureException } from "@sentry/react";

export function reportToSentry(
  error: Error,
  context: { url: string; method: string; service: string }
): void {
  captureException(error, {
    tags: { module: "network", service: context.service },
    extra: { url: context.url, method: context.method },
  });
}
